var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 34,
    viewBox: "0 0 27 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.7017V6.70167C20 3.00667 17.025 0 13.3684 0C13.251 0.00070484 13.1342 0.0146826 13.02 0.0416666C11.3088 0.124634 9.6949 0.862257 8.51232 2.10192C7.32974 3.34158 6.66895 4.98841 6.66669 6.70167V16.7017C6.66669 20.3783 9.65669 23.3683 13.3334 23.3683C17.01 23.3683 20 20.3783 20 16.7017ZM10 16.7017V6.70167C10 4.86333 11.495 3.36833 13.3334 3.36833C13.4245 3.36836 13.5154 3.35999 13.605 3.34333C15.3134 3.46833 16.6667 4.92667 16.6667 6.70167V16.7017C16.6667 18.54 15.1717 20.035 13.3334 20.035C11.495 20.035 10 18.54 10 16.7017Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 16.7017H0C0 23.4883 5.10167 29.095 11.6667 29.92V33.3683H15V29.92C21.565 29.095 26.6667 23.49 26.6667 16.7017H23.3333C23.3333 22.2167 18.8483 26.7017 13.3333 26.7017C7.81833 26.7017 3.33333 22.2167 3.33333 16.7017Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/MICROPHONE.560c266a300eebff60e6312be511cfe3.svg";
export { ForwardRef as ReactComponent };